"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentRequest = exports.AppointmentDayPreference = exports.AppointmentWeekDay = exports.AppointmentDayTime = void 0;
const infrastructure_1 = require("../../../infrastructure");
const utils_1 = require("@leavy/utils");
const validator_1 = require("@leavy/validator");
var AppointmentDayTime;
(function (AppointmentDayTime) {
    AppointmentDayTime["MORNING"] = "MORNING";
    AppointmentDayTime["NOON"] = "NOON";
    AppointmentDayTime["AFTERNOON"] = "AFTERNOON";
})(AppointmentDayTime = exports.AppointmentDayTime || (exports.AppointmentDayTime = {}));
var AppointmentWeekDay;
(function (AppointmentWeekDay) {
    AppointmentWeekDay["MONDAY"] = "MONDAY";
    AppointmentWeekDay["TUESDAY"] = "TUESDAY";
    AppointmentWeekDay["WEDNESDAY"] = "WEDNESDAY";
    AppointmentWeekDay["THURSDAY"] = "THURSDAY";
    AppointmentWeekDay["FRIDAY"] = "FRIDAY";
})(AppointmentWeekDay = exports.AppointmentWeekDay || (exports.AppointmentWeekDay = {}));
class AppointmentDayPreference extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.times = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.day) && utils_1.Guard.Enum.isEnumMember(AppointmentWeekDay)(this.day)
            && (utils_1.Guard.isNotNullish(this.times)
                && this.times.length > 0
                && this.times.every(x => utils_1.Guard.Enum.isEnumMember(AppointmentDayTime)(x))));
    }
    toPlain() {
        return { ...this };
    }
}
exports.AppointmentDayPreference = AppointmentDayPreference;
class AppointmentRequest extends infrastructure_1.ValueObjectBase {
    constructor(data) {
        super();
        this.preferredDays = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.preferredDays)
            && this.preferredDays.length > 0
            && this.preferredDays.every(x => x.isComplete()));
    }
    toPlain() {
        return { ...this };
    }
}
__decorate([
    (0, validator_1.Type)(() => AppointmentDayPreference),
    __metadata("design:type", Array)
], AppointmentRequest.prototype, "preferredDays", void 0);
exports.AppointmentRequest = AppointmentRequest;
//# sourceMappingURL=AppointmentRequest.js.map